import { useState } from "react";
import { useNavigate } from "react-router";
import { useQuery } from "@apollo/client/react";

import { NotificationListPage as Component } from "../../../components/pages/notification/NotificationListPage";
import { GET_CS_NOTIFICATIONS } from "../../../graphql/queries";
import { useCheckUserRole } from "../../../hooks/useCheckUserRole";

export const NotificationListPage = () => {
  useCheckUserRole();
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);

  const { data, loading } = useQuery(GET_CS_NOTIFICATIONS, {
    variables: { input: { take: 20, page: currentPage } },
    fetchPolicy: "network-only",
  });

  const notifications = data?.csNotifications?.notifications ?? [];
  const totalCount = data?.csNotifications?.totalCount ?? 0;

  return (
    <Component
      loading={loading}
      notifications={notifications}
      totalCount={totalCount}
      currentPage={currentPage}
      onRowClick={(id) => navigate(`/notifications/${id}`)}
      onCreateClick={() => navigate("/notifications/create")}
      onPageChange={setCurrentPage}
    />
  );
};
